module.exports = __webpack_public_path__ + "img/closeeye.90d02c24.svg";